/* eslint-disable @typescript-eslint/no-explicit-any */
import { requestGetReport06 } from 'app/api/report'
import { ReportMessageCode } from 'app/api/report/constant'
import { IResponseGetReport06 } from 'app/api/report/model/report-06'
import { IResponseFilter } from 'app/components/tables/BaseTableReport/FilterReport/type'
import { IDataBaseTable } from 'app/components/tables/BaseTableReport/type'
import { initFilterTable } from 'app/hook'
import { isEqual } from 'lodash'
import {
  DateUtil,
  FORMAT_CENTER_YYYY_MM_DD,
  convertPercent,
  initialPagination,
  moment
} from 'parkway-web-common'
import { useEffect, useMemo, useState } from 'react'
import { convertDataToTable, useCommonHook } from './common-hook'
import { IDataReport006 } from './data'
import { TreatmentGroupEnum } from 'app/constant'

export const useTableHook = () => {
  const [filterResponse, setFilterResponse] =
    useState<IResponseFilter>(initFilterTable())

  const [listServiceName, setListServiceName] = useState<string[]>([])

  const getYearStartAndEnd = (
    year: number,
  ): { startDate: Date; endDate: Date } => {
    const startDate = new Date(year, 0, 1, 0, 0, 0, 0)

    // Create a new Date object with the specified year and set the month to 11 (December) and day to 31
    // Set the time to 23:59:59.999 to get the last second of the year
    const endDate = new Date(year, 11, 31, 23, 59, 59, 999)

    return { startDate, endDate }
  }
  const params = useMemo(() => {
    const { year, month, week, selectFilterType } = filterResponse

    if (selectFilterType === 'WEEK') {
      return {
        startDate: DateUtil.formatDate(
          week?.startDate ?? '',
          FORMAT_CENTER_YYYY_MM_DD,
        ),
        endDate: DateUtil.formatDate(
          week?.endDate ?? '',
          FORMAT_CENTER_YYYY_MM_DD,
        ),
      }
    }

    if (selectFilterType === 'YEAR') {
      const formatyear = getYearStartAndEnd(Number(year))

      const formatYear = moment(formatyear.endDate).year()

      const startDate = moment()
        .year(formatYear)
        .startOf('year')
        .format(FORMAT_CENTER_YYYY_MM_DD)

      const endDate = moment()
        .year(formatYear)
        .endOf('year')
        .format(FORMAT_CENTER_YYYY_MM_DD)

      return {
        startDate,
        endDate,
      }
    }

    const momentOfMonth = moment(`${year}-${month}-01`)

    return {
      startDate: DateUtil.formatDate(
        momentOfMonth?.startOf('month').toDate(),
        FORMAT_CENTER_YYYY_MM_DD,
      ),
      endDate: DateUtil.formatDate(
        momentOfMonth?.endOf('month').toDate(),
        FORMAT_CENTER_YYYY_MM_DD,
      ),
    }
  }, [filterResponse])

  const handleChangeFilter = (filter: IResponseFilter) => {
    setFilterResponse(filter)
  }

  const [tableData, setTableData] = useState<{
    data: any[]
    loading: boolean
  }>({
    data: [],
    loading: false,
  })

  const [expandedRowKeys, setExpandedRowKeys] = useState<number[]>([])

  const handleExpand = (expanded: boolean, newKey?: number) => {
    if (!newKey) return

    if (expanded) {
      setExpandedRowKeys([...expandedRowKeys, newKey])
    } else {
      setExpandedRowKeys(expandedRowKeys.filter(key => key !== newKey))
    }
  }

  const getDataWeek = async () => {
    const initData = {
      pagination: initialPagination,
      data: [],
    } as IDataBaseTable<IDataReport006>
    try {
      const response: IResponseGetReport06 = await requestGetReport06(params)
      if (
        isEqual(response?.msgcode, ReportMessageCode.Report06.successGetData)
      ) {
        const data = response?.data?.rows ?? []
        let dataTable: IDataReport006[] = []
        const metadata = response?.data?.metadata?.total
        const listTreatmentGroup = (metadata?.products?.map(
          item => item?.treatmentgroupName ?? '',
        ) ?? []) as TreatmentGroupEnum[]

        data.forEach((area, index) => {
          const [firstClinicOfArea, ...otherClinicOfArea] = area?.children ?? []

          const dataOfFirstClinic = convertDataToTable(
            firstClinicOfArea?.products ?? [],
            'normal',
            listTreatmentGroup,
          )

          const dataOfArea = convertDataToTable(
            area?.products ?? [],
            'total',
            listTreatmentGroup,
          )

          const saveData: IDataReport006 = {
            key: index + 1,
            area: area?.areName,
            clinic: firstClinicOfArea?.name,
            ...dataOfFirstClinic,
            ...dataOfArea,
            totalRevenueActual: firstClinicOfArea?.totalActual,
            totalRevenuePlan: firstClinicOfArea?.budgetPlan,
            percentTargetComplete: firstClinicOfArea?.targetPercent,
            totalRevenueActualTotal: area?.totalActual,
            totalRevenuePlanTotal: area?.budgetPlan,
            percentTargetCompleteTotal: area.targetPercent,
            children: otherClinicOfArea?.map((clinic, idx) => {
              const dataOfClinic = convertDataToTable(
                clinic?.products ?? [],
                'normal',
                listTreatmentGroup,
              )
              return {
                key: Number((index + 1) * 100 + idx),
                clinic: clinic?.name,
                parentKey: index + 1,
                index: idx + 1,
                ...dataOfClinic,
                totalRevenueActual: clinic?.totalActual,
                totalRevenuePlan: clinic?.budgetPlan,
                percentTargetComplete: clinic?.targetPercent,
              }
            }),
          }
          dataTable = dataTable.concat([saveData])
        })

        const dataTableOfMetadata = convertDataToTable(
          metadata?.products ?? [],
          'normal',
          listTreatmentGroup,
        )

        setListServiceName(listTreatmentGroup)

        const dataOfTable: IDataReport006 = {
          area: 'Tổng',
          key: dataTable?.length + 1,
          isTotalTable: true,
          totalRevenueActual: metadata?.totalActual,
          totalRevenuePlan: metadata?.budgetPlan,
          percentTargetComplete: convertPercent(
            metadata?.totalActual,
            metadata?.budgetPlan,
          ),
          ...dataTableOfMetadata,
        }

        return {
          ...initData,
          data: [...dataTable, dataOfTable],
        }
      }
      return initData
    } catch (error) {
      return initData
    }
  }

  const fetchLoading = (isLoading: boolean) => {
    setTableData(prev => ({
      ...prev,
      loading: isLoading,
    }))
  }

  const fetchData = async () => {
    setTableData(tableData => {
      return { ...tableData, loading: true }
    })
    const res = await getDataWeek()

    setTableData({
      data: res?.data,
      loading: false,
    })
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData()
    }, 650)

    return () => clearTimeout(timer)
  }, [params])

  const { columns, exportExcel } = useCommonHook({
    expandedRowKeys,
    typeHook: isEqual(filterResponse?.selectFilterType, 'MONTH')
      ? 'month'
      : 'week',
    handleExpand,
    tableData,
    fetchLoading,
    currentFilter: params,
    listServiceName,
  })

  return {
    columns,
    tableData,
    handleExpand,
    expandedRowKeys,
    handleChangeFilter,
    filterResponse,
    exportExcel,
  }
}
